import api from "../utils/api";
import {
    LOGOUT, PERMISSIONS_LOADED
} from "./types";

const failure = (err, fallback) => ({
    success: false,
    fatal: true,
    status: err?.response?.status || 500,
    message: err?.response?.data?.message || err?.response?.data?.error?.message || err?.message || fallback,
    error: err?.response?.data?.error || err?.response?.data || null
});

export const list = () => async (dispatch) => {
    try {
        const res = await api.get(`/permissions`);
        return res.data;
    } catch (err) {
        if (err?.response?.status === 401) dispatch({ type: LOGOUT });
        return failure(err, "Permission list failed");
    }
}

export const user = ({uuid}) => async (dispatch) => {
    try {
        const res = await api.get(`/permissions/user/i/${uuid}`);
        return res.data;
    } catch (err) {
        if (err?.response?.status === 401) dispatch({ type: LOGOUT });
        return failure(err, "User permission lookup failed");
    }
}

export const mine = () => async (dispatch) => {
    try {
        const res = await api.get(`/permissions/me`);
        dispatch({
            type: PERMISSIONS_LOADED,
            payload: res.data
        });
        return res.data;
    } catch (err) {
        if (err?.response?.status === 401) dispatch({ type: LOGOUT });
        return failure(err, "Permission profile failed");
    }
}

export const grant = (uuid, name) => async (dispatch) => {
    try {
        const res = await api.post(`/permissions/update`, {
            userUuid: uuid,
            permission: name,
            grant: true
        });
        return res.data;
    } catch (err) {
        if (err?.response?.status === 401) dispatch({ type: LOGOUT });
        return failure(err, "Permission grant failed");
    }
}

export const deny = (uuid, name) => async (dispatch) => {
    try {
        const res = await api.post(`/permissions/update`, {
            userUuid: uuid,
            permission: name,
            grant: false
        });
        return res.data;
    } catch (err) {
        if (err?.response?.status === 401) dispatch({ type: LOGOUT });
        return failure(err, "Permission revoke failed");
    }
}
